import { createContext } from "react";

const MonthlyPremiumInvoicesContext = createContext();

export default MonthlyPremiumInvoicesContext;
